import AnalyticsSettingsLink from "./AnalyticsSettingsLink";

function LegalLinks({
  className = "",
  linkClassName = "",
  analyticsClassName = "",
  showSeparators = false,
}) {
  const separator = showSeparators ? <span aria-hidden="true">·</span> : null;

  return (
    <nav
      aria-label="Privacy and legal"
      className={`flex items-center ${showSeparators ? "gap-x-3" : "gap-8"} ${className}`}
    >
      <a href="/privacy" className={linkClassName}>Privacy</a>
      {separator}
      <AnalyticsSettingsLink className={analyticsClassName} />
      {separator}
      <a href="/terms" className={linkClassName}>Terms</a>
    </nav>
  );
}

export default LegalLinks;
